import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 1551.3 1309.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M896.6 0c-41.3 0-81.8 3.8-121 11.1 303.8 56.8 533.8 300.3 533.8 620.7 0 228-184.8 436-412.8 436-42.1 0-82.7-6.3-121-18-168.9-51.7-291.8-209-291.8-394.9S606.7 311.7 775.6 260c-38.2-11.7-78.8-18.1-120.9-18.1-228 0-412.8 208-412.8 436.1 0 320.3 229.9 563.8 533.7 620.6 39.2 7.3 79.7 11.2 121 11.2 361.5 0 654.7-293.2 654.7-654.9S1258.1 0 896.6 0Z",
      style: {"fill":"#c1bfbc"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M654.7 0c41.3 0 81.7 3.8 120.9 11.1 303.8 56.8 533.8 300.3 533.8 620.7 0 228-184.8 436-412.8 436-42.1 0-82.7-6.3-121-18 169-51.7 291.9-209 291.9-394.9S944.6 311.7 775.6 260c-38.2-11.7-78.8-18.1-120.9-18.1-228 0-412.8 208-412.8 436.1 0 320.3 229.9 563.8 533.7 620.6-39.2 7.3-79.6 11.2-120.9 11.2C293.1 1309.8 0 1016.6 0 654.9S293.1 0 654.7 0Z",
      style: {"fill":"#ee7203"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "G3-logo"}) } }